import React from "react";
import HisDirectorPerson from "@/app/(index)/leader/[name]/his-director-person";
import {useMediaQuery} from "@mantine/hooks";
import HisDirectorPersonSM from "@/app/(index)/leader/[name]/his-director-person-sm";


export default function HisDirector() {

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className="flex flex-col ">

            {
                mediaQueryLessSM && (
                    <>
                        <HisDirectorPerson iconIndex={"15"} name="林俊良" nameEn="Chun-Liang Lin" termOfOffice="115,01,115,09" isFirst={true}/>
                        <HisDirectorPerson iconIndex={"14"} name="黃錫瑜" nameEn="Shi-Yu Huang" termOfOffice="113,08,114,12"/>
                        <HisDirectorPerson iconIndex={"13"} name="林博文" nameEn="Bou-Wen Lin" termOfOffice="109,08,113,08"/>
                        <HisDirectorPerson iconIndex={"12"} name="莊裕澤" nameEn="Yuh-Jzer Joung" termOfOffice="102,08,109,09"/>
                        <HisDirectorPerson iconIndex={"11"} name="林博文" nameEn="Bou-Wen Lin" termOfOffice="98,06,102,07"/>
                        <HisDirectorPerson iconIndex={"10"} name="王永和" nameEn="Yeong-Her Wang" termOfOffice="98,01,98,06"
                                           line1="副院長" line2="兼" line3="代理主任" line1En="Vice President" line2En="and"
                                           line3En="Acting Director General"/>
                        <HisDirectorPerson iconIndex={"09"} name="王丕承" nameEn="Pe-Cheng Wang" termOfOffice="96,08,97,12"/>
                        <HisDirectorPerson iconIndex={"08"} name="鄒篪生" nameEn="Chih-Sheng Tsou" termOfOffice="96,01,96,07"
                                           line1="代理主任" line1En="Acting Director General"/>
                        <HisDirectorPerson iconIndex={"07"} name="蔡嘉寅" nameEn="Chia-Yin Tsai" termOfOffice="94,01,95,12"/>
                        <HisDirectorPerson iconIndex={"06"} name="孟憲鈺" nameEn="Xian-Yu Meng" termOfOffice="88,09,94,01"/>
                        <HisDirectorPerson iconIndex={"05"} name="劉錦龍" nameEn="Chin-Lung Liu" termOfOffice="84,03,88,09"/>
                        <HisDirectorPerson iconIndex={"04"} name="馬道行" nameEn="Tao-Hsing Ma" termOfOffice="74,07,84,03"/>
                        <HisDirectorPerson iconIndex={"03"} name="劉仲凌" nameEn="Chung-Ling Liu" termOfOffice="71,03,74,06"/>
                        <HisDirectorPerson iconIndex={"02"} name="方同生" nameEn="Tung-Sheng Fang" termOfOffice="67,08,71,03"/>
                        <HisDirectorPerson iconIndex={"01"} name="沈曾圻" nameEn="Tseng-Chi Shen" termOfOffice="63,03,67,08"/>
                    </>
                )
            }

            {
                !mediaQueryLessSM && (
                    <>
                        <HisDirectorPersonSM iconIndex={"15"} name="林俊良" nameEn="Chun-Liang Lin" termOfOffice="115,01,115,09" isFirst={true}/>
                        <HisDirectorPersonSM iconIndex={"14"} name="黃錫瑜" nameEn="Shi-Yu Huang" termOfOffice="113,08,114,12"/>
                        <HisDirectorPersonSM iconIndex={"13"} name="林博文" nameEn="Bou-Wen Lin" termOfOffice="109,08,113,08"/>
                        <HisDirectorPersonSM iconIndex={"12"} name="莊裕澤" nameEn="Yuh-Jzer Joung" termOfOffice="102,08,109,09"/>
                        <HisDirectorPersonSM iconIndex={"11"} name="林博文" nameEn="Bou-Wen Lin" termOfOffice="98,06,102,07"/>
                        <HisDirectorPersonSM iconIndex={"10"} name="王永和" nameEn="Yeong-Her Wang" termOfOffice="98,01,98,06"
                                           line1="副院長" line2="兼" line3="代理主任" line1En="Vice President" line2En="and"
                                           line3En="Acting Director General"/>
                        <HisDirectorPersonSM iconIndex={"09"} name="王丕承" nameEn="Pe-Cheng Wang" termOfOffice="96,08,97,12"/>
                        <HisDirectorPersonSM iconIndex={"08"} name="鄒篪生" nameEn="Chih-Sheng Tsou" termOfOffice="96,01,96,07"
                                           line1="代理主任" line1En="Acting Director General"/>
                        <HisDirectorPersonSM iconIndex={"07"} name="蔡嘉寅" nameEn="Chia-Yin Tsai" termOfOffice="94,01,95,12"/>
                        <HisDirectorPersonSM iconIndex={"06"} name="孟憲鈺" nameEn="Xian-Yu Meng" termOfOffice="88,09,94,01"/>
                        <HisDirectorPersonSM iconIndex={"05"} name="劉錦龍" nameEn="Chin-Lung Liu" termOfOffice="84,03,88,09"/>
                        <HisDirectorPersonSM iconIndex={"04"} name="馬道行" nameEn="Tao-Hsing Ma" termOfOffice="74,07,84,03"/>
                        <HisDirectorPersonSM iconIndex={"03"} name="劉仲凌" nameEn="Chung-Ling Liu" termOfOffice="71,03,74,06"/>
                        <HisDirectorPersonSM iconIndex={"02"} name="方同生" nameEn="Tung-Sheng Fang" termOfOffice="67,08,71,03"/>
                        <HisDirectorPersonSM iconIndex={"01"} name="沈曾圻" nameEn="Tseng-Chi Shen" termOfOffice="63,03,67,08"/>
                    </>
                )
            }



        </div>
    );
}
